import PropTypes from 'prop-types';
import i18n from './index';

export const i18nChangeLanguage = lang => {
  const _lang = lang.toLowerCase();
  if (_lang === 'init') {
    i18n.init();
  } else {
    i18n.changeLanguage(_lang);
  }
};

i18nChangeLanguage.propTypes = {
  lang: PropTypes.string,
};

i18nChangeLanguage.defaultProps = {
  lang: 'init',
};

export default i18nChangeLanguage;
